<template>
  <div>
    <b-loading :active="loading" />
    <h2 class="mt-5 font-medium text-xl">
      人員名單
    </h2>

    <div class="bg-white flex gap-6 mt-4 pb-20 pt-4 px-4">
      <template v-if="departments?.length">
        <div class="w-2/3">
          <div class="flex mb-4">
            <div class="flex-1">
              <p class="control has-icons-right">
                <input
                  v-model="keyword"
                  class="input"
                  type="text"
                  placeholder="直接搜尋同事姓名、人員編號或分機"
                  @keypress.enter="getMembers"
                >
              </p>
            </div>
            <div class="flex-1">
              <w-button
                :disabled="!keyword"
                class="ml-4"
                size="sm"
                @click="getMembers"
              >
                搜尋
              </w-button>
              <w-button
                :disabled="!keyword"
                class="ml-6"
                color-type="secondary"
                size="sm"
                type="link"
                @click="clearSearch"
              >
                清除
              </w-button>
            </div>
          </div>
          <member-table
            :allow-edit-type="allowEditType"
            :current-page="page"
            :members="members"
            :origin-selected-members="originSelectedData"
            :per-page="perPage"
            :search="search"
            :selected-department-ids="resolvedDepartmentIds"
            :selected-members="selectedMembers"
            :sort-field="sortField"
            :sort-order="sortOrder"
            :total-page="totalPage"
            @selected-departments="onSelectedDepartments"
            @set-selected-member="setSelectedMember"
            @sort="onSort"
            @update-selected-members="setAllSelectedMembers"
          />
          <div v-if="total && !loading" class="flex gap-4 items-center">
            <b-select v-model="perPage">
              <option
                v-for="option in perPageOptions"
                :value="option.value"
                :key="option.label"
              >
                {{ option.label }}
              </option>
            </b-select>
            <div class="flex-grow">
              <b-pagination
                :total="total"
                v-model="page"
                range-before="3"
                range-after="1"
                nextIcon="right-chevron"
                prevIcon="left-chevron"
                :per-page="perPage"
              />
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <expected-order-count :statistics="statistics" class="mb-4" />
          <joined-members
            :allow-edit-type="allowEditType"
            :members="members"
            :order-type="orderType"
            :selected-members="selectedMembers"
            :origin-selected-members="originSelectedData"
            @clear="clearAllSelected"
            @remove-selected-department="removeSelectedDepartment"
          />
        </div>
      </template>
      <div
        v-else
        class="px-4"
      >
        <div class="py-2">
          尚未建立名單喔，立刻前往
          <router-link to="/member/list">
            人員管理
          </router-link>
          建立吧！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberSelector from './MemberSelector';

export default MemberSelector;
</script>

<style lang="scss" scoped>
@import 'MemberSelector';
</style>
